/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SignoutRequest } from '../models/SignoutRequest';
import type { SignoutResponse } from '../models/SignoutResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InternalUserSessionsService {
    /**
     * Sign out a user's portal sessions (internal)
     * @param userId
     * @param requestBody
     * @returns SignoutResponse Successful Response
     * @throws ApiError
     */
    public static signoutPortalUserSessions(
        userId: string,
        requestBody: SignoutRequest,
    ): CancelablePromise<SignoutResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/users/{user_id}/signout',
            path: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Sign out a user's mobile sessions for a specific device (internal)
     * @param userId
     * @param deviceId
     * @returns SignoutResponse Successful Response
     * @throws ApiError
     */
    public static signoutPortalDeviceSessions(
        userId: string,
        deviceId: string,
    ): CancelablePromise<SignoutResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/users/{user_id}/devices/{device_id}/signout',
            path: {
                'user_id': userId,
                'device_id': deviceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
